<template>
  <div class="d-flex flex-row justify-content-center">
      <div class="p-2" >
        <span>رمز یک‌بار مصرف به شماره <span>{{ phone_number }}</span> پیامک شد.  </span><br><span
          class="btn  text-danger" @click="back">  ویرایش شماره</span>
      </div>
  </div>
    <div class="d-flex flex-row handleInput justify-content-center ">
        <div style="display: flex; align-items: center;">
          <input min="0" max="9" maxlength="1" pattern="[0-9]" type="tel" class="otp-input" id="inputSex"
                 v-on:keyup="handleInput('inputSex','end' , phone_number)">
        </div>
        <div style="display: flex; align-items: center;">
          <input min="0" max="9" maxlength="1" pattern="[0-9]" type="tel" class="otp-input" id="inputFive"
                 v-on:keyup="handleInput('inputFive','inputSex' ,'')">
        </div>
        <div style="display: flex; align-items: center;">
          <input min="0" max="9" maxlength="1" pattern="[0-9]" type="tel" class="otp-input" id="inputFoure"
                 v-on:keyup="handleInput('inputFoure','inputFive','')">
        </div>

        <div style="display: flex; align-items: center;">
          <input min="0" max="9" maxlength="1" pattern="[0-9]" type="tel" class="otp-input" id="inputThree"
                 v-on:keyup="handleInput('inputThree','inputFoure','')">
        </div>

        <div style="display: flex; align-items: center;">
          <input min="0" max="9" maxlength="1" pattern="[0-9]" type="tel" class="otp-input" id="inputTwo"
                 v-on:keyup="handleInput('inputTwo','inputThree','')">
        </div>
        <div style="display: flex; align-items: center;">
          <input min="0" max="9" v-on:keyup="handleInput('inputOne','inputTwo','')" maxlength="1" pattern="[0-9]"
                 type="tel"
                 class="otp-input" id="inputOne">
        </div>

    </div>
    <div v-if="timers ==='true'">
      <div class="d-flex flex-row mt-2 justify-content-center ">
        <div class="p-2 ">
          <h1 class="text-justify p-2" style="text-align: justify; font-size: 12px; font-weight: bold;">تا  <span
                class="text-danger  " id="date"> {{ date }} </span> ارسال مجدد رمز یک‌بار مصرف به شماره شما امکان‌پذیر
            است.
          </h1>
        </div>
      </div>
      <div class="d-flex flex-row mt-2">
        <div class="p-2 w-100 ">

          <button  disabled type="button"  v-if="statusFirst === 'true'" class=" form-control text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 shadow-lg shadow-red-500/50 dark:shadow-lg dark:shadow-red-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
            <svg aria-hidden="true" role="status" class="inline w-4 h-4 me-3 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2"/>
            </svg>
            ... در حال بررسی کد
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <h1 class="text-justify p-2 mt-2" style="text-align: justify; font-size: 12px; font-weight: bold;">
        <span @click="restart(phone_number)" class="btn text-danger font-weight-bold">ارسال مجدد</span>
      </h1>
    </div>
</template>
<script setup>
import {useStore} from "vuex";
import {useToast} from "vue-toastification";
import {$ref} from "vue/macros";
import {computed} from "vue";
import axios from "axios";
import * as localStorages from "@/common/helpers/localStorages";
import * as login from "@/agent/components/Login/login"
import * as errors from "@/common/helpers/errors";


const store = useStore()
const toast = useToast();
const phone_number = computed(() => {
  return store.state.phone_number
});


let statusFirst = $ref("false");
let timers = $ref('true');
let date = $ref();
let codes = "";
let result = $ref([]);

function back() {
  return store.dispatch('loginActionsStep', {'status': 'step1'})
}

function handleInput(id, next, phone_number = null) {

  let val = document.getElementById(id).value;
  codes += val;
  if (codes.length === 6) {
    login.disabled()
    sendData(phone_number)
  }

  if (next === 'end') return false;
  document.getElementById(next).focus();
}

async function sendData(phone_number) {
  localStorages.localStoragesLoginRemove()
  if (!codes) return toast.warning('کد اجباری می باشد');
  statusFirst = 'true'
  try {
    const response = await axios.get(`agents/login/?phone_number=${phone_number}&code=${codes}`);
    if (response.data.status === "true") {
      localStorages.localStoragesLoginAdd(response);
      window.location.replace('/agents/panel/dashboard')
    }

  } catch (error) {
    statusFirst = 'false'
    login.enabled()
    codes = "";
    errors.myErrors(error)
  }
}

function countdown(totalSeconds) {

  let minutes = Math.floor(totalSeconds / 60);
  let seconds = totalSeconds % 60;
  date = `${padZero(minutes)}:${padZero(seconds)}`;
  if (totalSeconds > 0) {
    setTimeout(function () {
      countdown(totalSeconds - 1);
    }, 1000);
  } else {
    timers = 'false';
  }
}

function padZero(num) {
  return num.toString().padStart(2, '0');
}

async function restart(phone) {
  console.log(phone);
  const response = await axios.get(`agents/otp/?phone_number=${phone}`);
  if (response.data.status === "true") {
    timers = 'true';
    countdown(2 * 60)
    return true;
  }
}

countdown(2 * 60)
</script>
